import { takeLatest } from "redux-saga/effects";
import {
  getGuidelinesData,
  getFrequencyOptions,
  createGuidelineData,
  editGuidelineData,
  updateGuidelineData,
  deleteGuidelineData,
  toggleGuidelineStatus,
} from "../../StateManagement/Reducers/PreventiveGuidelinesState";
import {
  fetchGuidelinesWorker,
  fetchFrequencyOptionsWorker,
  createGuidelineWorker,
  editGuidelineWorker,
  updateGuidelineWorker,
  deleteGuidelineWorker,
  toggleGuidelineStatusWorker,
} from "./PreventiveGuidelinesWorker";

export function* PreventiveGuidelinesWatcher() {
  yield takeLatest(getGuidelinesData.type, fetchGuidelinesWorker);
  yield takeLatest(getFrequencyOptions.type, fetchFrequencyOptionsWorker);
  yield takeLatest(createGuidelineData.type, createGuidelineWorker);
  yield takeLatest(editGuidelineData.type, editGuidelineWorker);
  yield takeLatest(updateGuidelineData.type, updateGuidelineWorker);
  yield takeLatest(deleteGuidelineData.type, deleteGuidelineWorker);
  yield takeLatest(toggleGuidelineStatus.type, toggleGuidelineStatusWorker);
}
